<div class="kontrolltermin-preview">
  <!-- Generation Controls -->
  <div class="mb-4 p-3 bg-gray-50 rounded-md">
    <h3 class="text-sm font-medium text-gray-700 mb-3">Kontrolltermine generieren</h3>
    
    <div class="flex items-end justify-between gap-x-6">
      <div class="min-w-0 flex-1">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Von Monat</label>
            <select [(ngModel)]="fromMonth" 
                    (change)="onDateRangeChange()"
                    class="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500">
              <option *ngFor="let month of months" [value]="month.value">{{month.label}}</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Von Jahr</label>
            <select [(ngModel)]="fromYear" 
                    (change)="onDateRangeChange()"
                    class="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500">
              <option *ngFor="let year of years" [value]="year">{{year}}</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Bis Monat</label>
            <select [(ngModel)]="toMonth" 
                    (change)="onDateRangeChange()"
                    class="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500">
              <option *ngFor="let month of months" [value]="month.value">{{month.label}}</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Bis Jahr</label>
            <select [(ngModel)]="toYear" 
                    (change)="onDateRangeChange()"
                    class="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500">
              <option *ngFor="let year of years" [value]="year">{{year}}</option>
            </select>
          </div>
        </div>
      </div>
      
      <div class="flex flex-col gap-y-2">
        <button (click)="generateKontrolltermine(false)" 
                [disabled]="isGenerating"
                mat-raised-button
                color="primary">
          <mat-icon class="mr-2 w-5 h-5">schedule</mat-icon>
          <span *ngIf="!isGenerating">Kontrolltermine generieren</span>
          <span *ngIf="isGenerating" class="flex items-center justify-center">
            <mat-spinner diameter="16" class="mr-2"></mat-spinner>
            Generiere...
          </span>
        </button>
        <button (click)="generateKontrolltermine(true)" 
                [disabled]="isGenerating"
                mat-raised-button
                class="text-gray-700 bg-gray-100 hover:bg-gray-200">
          <mat-icon class="mr-2 w-5 h-5">settings</mat-icon>
          <span *ngIf="!isGenerating">Test Run</span>
          <span *ngIf="isGenerating" class="flex items-center justify-center">
            <mat-spinner diameter="16" class="mr-2"></mat-spinner>
            Teste...
          </span>
        </button>
      </div>
    </div>

    <!-- Test Run Preview -->
    <div *ngIf="showTestRunPreview" class="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <div class="flex justify-between items-center mb-3">
        <h4 class="text-sm font-semibold text-blue-800">Test Run Vorschau</h4>
        <button (click)="closeTestRunPreview()" mat-icon-button class="text-blue-600 hover:text-blue-800">
          <mat-icon class="w-4 h-4">close</mat-icon>
        </button>
      </div>
      
      <!-- Summary Statistics -->
      <div class="mb-4 p-3 bg-white rounded border">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
          <div class="text-center">
            <div class="font-semibold text-lg text-gray-800">{{getTotalKontrolltermine()}}</div>
            <div class="text-gray-600">Gesamt</div>
          </div>
          <div class="text-center">
            <div class="font-semibold text-lg text-green-600">{{getCreatedCount()}}</div>
            <div class="text-gray-600">Würden erstellt</div>
          </div>
          <div class="text-center">
            <div class="font-semibold text-lg text-yellow-600">{{getSkippedCount()}}</div>
            <div class="text-gray-600">Übersprungen</div>
          </div>
          <div class="text-center">
            <div class="font-semibold text-lg text-red-600">{{getErrorCount()}}</div>
            <div class="text-gray-600">Fehler</div>
          </div>
        </div>
      </div>
      
      <div *ngFor="let group of testRunPreview" class="mb-4">
        <div class="bg-white p-3 rounded border">
          <h5 class="font-medium text-sm text-gray-800 mb-2">
            {{group.projektaufgabe?.beschreibung || ('Projektaufgabe ' + group.projektaufgabe_id.substring(0, 8))}}
          </h5>
          <div class="text-xs text-gray-600 mb-3">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div>
                <span class="font-medium">Periodizität:</span> 
                {{getPeriodizitaetLabel(group.projektaufgabe?.periodizitaet)}}
              </div>
              <div *ngIf="getPeriodizitatSerieLabel(group.projektaufgabe)">
                <span class="font-medium">Periodizität Serie:</span> 
                {{getPeriodizitatSerieLabel(group.projektaufgabe)}}
              </div>
              <div>
                <span class="font-medium">Anzahl Kontrolltermine:</span> 
                {{group.kontrolltermine?.length || 0}}
              </div>
            </div>
          </div>
          
          <div class="space-y-2">
            <div *ngFor="let kt of group.kontrolltermine" 
                 class="flex items-center justify-between p-3 bg-gray-50 rounded text-xs border-l-4"
                 [ngClass]="{
                   'border-green-400': kt.action === 'created',
                   'border-yellow-400': kt.action === 'skipped',
                   'border-red-400': kt.action === 'error'
                 }">
              <div class="flex items-center space-x-4 flex-1">
                <div class="font-medium text-gray-800">{{formatDate(kt.date)}}</div>
                <div class="text-gray-500 font-mono">{{kt.einsatznummer}}</div>
                <div class="text-gray-500">Kontrolle</div>
                <div class="text-gray-600">
                  <span class="font-medium">Kunde:</span> {{kt.kunde_name || '-'}}
                </div>
                <div class="text-gray-600">
                  <span class="font-medium">Techniker:</span> {{kt.techniker_name || '-'}}
                </div>
              </div>
              <div class="flex items-center space-x-2">
                <span class="px-2 py-1 rounded text-xs font-medium"
                      [ngClass]="{
                        'bg-green-100 text-green-800': kt.action === 'created',
                        'bg-yellow-100 text-yellow-800': kt.action === 'skipped',
                        'bg-red-100 text-red-800': kt.action === 'error'
                      }">
                  {{kt.status}}
                </span>
                <span *ngIf="kt.message" 
                      class="px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs max-w-xs truncate" 
                      [title]="kt.message">
                  {{kt.message}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="text-xs text-blue-700 mt-3 p-2 bg-blue-100 rounded">
        <mat-icon class="w-4 h-4 mr-1 align-text-bottom">info</mat-icon>
        Diese {{getTotalKontrolltermine()}} Kontrolltermine würden erstellt werden. 
        Klicken Sie "Generieren" um sie tatsächlich zu erstellen.
      </div>
    </div>

    <!-- Generation Status -->
    <div *ngIf="generationRun && !showTestRunPreview" class="mt-3 p-2 bg-white rounded border text-xs">
      <h4 class="font-medium mb-2 text-sm">Status</h4>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
        <div>
          <span class="text-gray-500">Kandidaten:</span>
          <span class="font-medium ml-1">{{generationRun.total_candidates}}</span>
        </div>
        <div>
          <span class="text-gray-500">Erstellt:</span>
          <span class="font-medium text-green-600 ml-1">{{generationRun.created_count}}</span>
        </div>
        <div>
          <span class="text-gray-500">Übersprungen:</span>
          <span class="font-medium text-yellow-600 ml-1">{{generationRun.skipped_existing_count}}</span>
        </div>
        <div>
          <span class="text-gray-500">Fehler:</span>
          <span class="font-medium text-red-600 ml-1">{{generationRun.errors_count}}</span>
        </div>
      </div>
      
      <!-- Generation Items Details -->
      <div *ngIf="generationItems.length > 0" class="mt-4">
        <h5 class="font-medium mb-2">Details:</h5>
        <div class="max-h-40 overflow-y-auto">
          <div *ngFor="let item of generationItems.slice(0, 10)" 
               class="flex items-center justify-between py-1 text-xs border-b border-gray-100 last:border-b-0">
            <span class="text-gray-600">{{item.datum}}</span>
            <span [ngClass]="{
              'text-green-600': item.action === 'created',
              'text-yellow-600': item.action === 'skipped',
              'text-red-600': item.action === 'error'
            }">
              {{item.action === 'created' ? 'Erstellt' : item.action === 'skipped' ? 'Übersprungen' : 'Fehler'}}
            </span>
            <span *ngIf="item.message" class="text-gray-500 truncate max-w-xs" [title]="item.message">
              {{item.message}}
            </span>
          </div>
          <div *ngIf="generationItems.length > 10" class="text-xs text-gray-500 mt-2">
            ... und {{generationItems.length - 10}} weitere
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Kontrolltermine Table -->
  <div class="bg-white rounded-lg shadow">
    <div class="px-4 py-2 border-b border-gray-200">
      <h3 class="text-sm font-semibold">Generierte Kontrolltermine</h3>
    </div>
    
    <div *ngIf="loading" class="p-8 text-center">
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      <p class="mt-2 text-gray-600">Lade Kontrolltermine...</p>
    </div>

    <div *ngIf="error" class="p-4 bg-red-50 border border-red-200 rounded-md">
      <p class="text-red-800">{{error}}</p>
    </div>

    <div *ngIf="!loading && !error && kontrolltermine?.length === 0" class="p-8 text-center text-gray-500">
      <p>Keine Kontrolltermine gefunden</p>
      <p class="text-sm mt-1">Generieren Sie Kontrolltermine für den gewählten Zeitraum</p>
    </div>

    <div *ngIf="!loading && !error && kontrolltermine?.length > 0" class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Termin</th>
            <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Projektaufgabe</th>
            <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kunde</th>
            <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Techniker</th>
            <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let kt of kontrolltermine" class="hover:bg-gray-50">
            <td class="px-3 py-2 whitespace-nowrap text-xs text-gray-900">
              {{kt.datum_durchfuerung | date:'dd.MM.yyyy'}}
            </td>
            <td class="px-3 py-2 text-xs text-gray-900">
              <div class="max-w-xs truncate" [title]="kt.projektaufgabe_beschreibung">
                {{kt.projektaufgabe_beschreibung}}
              </div>
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-xs text-gray-900">
              {{kt.kunde_name || '-'}}
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-xs text-gray-900">
              {{kt.techniker_name || '-'}}
            </td>
            <td class="px-3 py-2 whitespace-nowrap">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                    [ngClass]="getStatusClass(kt.status_id)">
                {{getStatusLabel(kt.status_id)}}
              </span>
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-xs font-medium">
              <button (click)="editKontrolltermin(kt)"
                      class="text-blue-600 hover:text-blue-900 font-medium">
                Bearbeiten
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
